<template>
 <div class="bg-white p-4 rounded-lg shadow">
  <apexchart type="area" :options="chartOptions" :series="series" />
 </div>
</template>

<script>
export default {
 name: "AreaChart",
 props: {
  series: {
   type: Array,
   required: true,
  },
  categories: {
   type: Array,
   required: true,
  },
  title: {
   type: String,
   default: "Time Utilization",
  },
 },
 computed: {
  chartOptions() {
   return {
    chart: {
     type: "area",
     height: 350,
     stacked: true,
     toolbar: { show: false },
    },
    title: {
     text: this.title,
     align: "left",
     style: {
      fontSize: "16px",
      color: "#333",
     },
    },
    subtitle: {
     text: this.$t("timeAllocationThroughoutDay"),
    },
    colors: ["#10b981", "#f59e0b", "#ef4444"],
    dataLabels: { enabled: false },
    stroke: {
     curve: "smooth",
     width: 2,
    },
    fill: {
     type: "gradient",
     gradient: {
      opacityFrom: 0.7,
      opacityTo: 0.3,
     },
    },
    legend: {
     position: "top",
     horizontalAlign: "right",
    },
    xaxis: {
     categories: this.categories,
     labels: {
      style: { colors: "#6b7280" },
     },
    },
    yaxis: {
     title: { text: "Minutes" },
     labels: {
      style: { colors: "#6b7280" },
     },
    },
    tooltip: {
     y: {
      formatter: function (val) {
       return val + " minutes";
      },
     },
    },
   };
  },
 },
};
</script>
